import React from 'react'
export default function Stopwatch({ className, style }) {
  return (
    <svg className={className} width="1em" height="1em" style={{ verticalAlign: '-0.125em', ...style }}
      viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.8"
      strokeLinecap="round" strokeLinejoin="round">
      <path d="M10 2h4" />
      <path d="M12 14v-4" />
      <path d="m19 6-1.5 1.5" />
      <circle cx="12" cy="14" r="8" />
    </svg>
  )
}
